// extracted by mini-css-extract-plugin
module.exports = {"tabsList":"tabs_tabsList__34RFY","accentBg":"tabs_accentBg__2Xkod","tabItem":"tabs_tabItem__327u6","active":"tabs_active__3IcAw"};